import Vue from 'vue';
import axios from 'axios';

export default {
  baseURL: process.env.BASE_URL + 'api/media',

  getVideoToken(surveyInstanceId, cancelToken) {
    return axios.get('get-upload-video',
      {
        baseURL: this.baseURL,
        params: {
          'survey-instance-id': surveyInstanceId
        }
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        console.log(error);
      });
  },
};
